import { OneBroker } from "@dune/types";
import { BrokerAccountingSelect } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { societiesQueryKeys } from "../query-keys/societies.query-keys";

export const getBrokerById = async (id: number): Promise<OneBroker> => {
	const { data } = await privateAxios.get<OneBroker>(`/societies/broker/${id}`);
	return data;
};

export const useGetBrokerById = (id: number) => {
	return useQuery({
		queryKey: societiesQueryKeys.broker(id),
		queryFn: async (): Promise<OneBroker> => {
			const response = await privateAxios.get(`/societies/broker/${id}`);
			return response.data;
		},
		enabled: !!id,
	});
};

export const getBrokerAccounting = async (id: number) => {
	const { data } = await privateAxios.get<BrokerAccountingSelect>(
		`/societies/broker/${id}/accounting`,
	);
	return data;
};

export const useGetBrokerAccounting = (id: number) => {
	return useQuery({
		queryKey: societiesQueryKeys.brokerAccounting(id),
		queryFn: () => getBrokerAccounting(id),
		enabled: !!id,
	});
};
